export default {
  "A confirmation code has just been sent to you by message": "Ein Bestätigungscode wurde Ihnen gerade per Nachricht zugesandt",
  "Already have an account": "Sie haben bereits ein Konto",
  "Beyond this time, the reservation we retain will be available again for others": "Über diesen Zeitraum hinaus steht die von uns behaltene Reservierung wieder für andere zur Verfügung",
  "Book now": "Buchen Sie jetzt",
  "Booking": "Buchung",
  "Booking information": "Buchungsinformation",
  "Booking start the first day at {startTime} and finish the last day at {endTime}": "Die Buchung beginnt am ersten Tag um {startTime} und endet am letzten Tag um {endTime}",
  "Cancel booking": "Buchung stornieren",
  "Choose your date": "Wählen Sie Ihr Datum",
  "Confirm my phone number": "Bestätige meine Telefonnummer",
  "Confirm my registration": "Meine Anmeldung bestätigen",
  "Confirm my booking": "Meine Buchung bestätigen",
  "Confirm my registration and pay": "Meine Anmeldung bestätigen und bezahlen",
  "Continue as guest": "Als Gast fortfahren",
  "Continue to registration": "Weiter zur Registrierung",
  "Create an account": "Ein Konto erstellen",
  "Dates": "Termine",
  "End Date of Reservation": "Enddatum der Reservierung",
  "Enlarge map": "Karte vergrößern",
  "Enter your code here to confirm your registration": "Geben Sie hier Ihren Code ein, um Ihre Registrierung zu bestätigen",
  "I accept the Terms and conditions of registration": "Ich akzeptiere die Anmeldebedingungen",
  "I accept the terms of service and confirm that I have read the privacy policy": "Ich akzeptiere die Nutzungsbedingungen und bestätige, dass ich die Datenschutzerklärung gelesen habe",
  "Loading…": "Wird geladen…",
  "Location": "Standort",
  "More information": "Mehr Informationen",
  "No slots available": "Keine Slots verfügbar",
  "Processing booking…": "Buchung wird bearbeitet…",
  "Processing payment…": "Zahlung verarbeiten…",
  "Product": "Produkt",
  "Recording payment…": "Zahlung wird erfasst…",
  "Reduce map": "Karte verkleinern",
  "Remaining time": "Verbleibende Zeit",
  "Required fields": "Benötigte Felder",
  "Reserving a product is mandatory for registration": "Für die Registrierung ist die Reservierung eines Produkts zwingend erforderlich",
  "Retrieving available slots": "Verfügbare Slots abrufen",
  "Saving registration…": "Registrierung wird gespeichert…",
  "Select size first": "Wählen Sie zuerst die Größe aus",
  "Select stage first": "Wählen Sie zuerst die Stufe aus",
  "Select your options and dates to book": "Wählen Sie Ihre Optionen und Daten für die Buchung aus",
  "Size": "Größe",
  "Slot": "Slot",
  "Stage": "Bühne",
  "Store": "Geschäft",
  "Start Date of Reservation": "Startdatum der Reservierung",
  "View privacy policy": "Datenschutzrichtlinie ansehen",
  "View terms and conditions": "Allgemeine Geschäftsbedingungen ansehen",
  "You do not want to create an account": "Sie möchten kein Konto erstellen",
  "The selected product has been set aside for you. You have {minutes} minutes to complete the process by providing your personal information.": "Das ausgewählte Produkt wurde für Sie reserviert. Sie haben {minutes} Minuten Zeit, um den Prozess abzuschließen, indem Sie Ihre persönlichen Informationen auf der nächsten Seite angeben.",
  "Your reservation is in progress!": "Ihre Reservierung wird bearbeitet!",
  "not available": "Nicht verfügbar",
  "remaining place": "verbleibender Platz|Restplätze",
  "see availability": "siehe Verfügbarkeit",
  "Email Address": "E-Mail-Adresse",
  "Phone": "Telefon",
  "Birthdate": "Geburtsdatum",
  "ProductTypes": "Produkttypen",
  "Sizes": "Größen",
  "Filter": "Filter",
  "Select a date": "Wählen Sie ein Datum aus",
  "Give us your opinion": "Geben Sie uns Ihre Meinung",
  "Thank you for your review!": "Vielen Dank für Ihre Bewertung!",
  "You can also review these products": "Sie können auch diese Produkte bewerten",
  "Undo": "Rückgängig",
  "Redo": "Wiederholen",
  "Bold": "Fett",
  "Italic": "Kursiv",
  "Strikethrough": "Durchgestrichen",
  "Paragraph": "Absatz",
  "Add Link": "Link hinzufügen",
  "Remove Link": "Link entfernen",
  "Headings": "Überschriften",
  "Heading 2": "Überschrift 2",
  "Heading 3": "Überschrift 3",
  "Heading 4": "Überschrift 4",
  "Heading 5": "Überschrift 5",
  "Heading 6": "Überschrift 6",
  "Bullet List": "Aufzählungsliste",
  "Numbered List": "Nummerierte Liste",
  "Clear Formatting": "Formatierung löschen",
  "Overall Rating": "Gesamtbewertung",
  "Review title": "Bewertungstitel",
  "Summarize your impression on the product": "Fassen Sie Ihren Eindruck vom Produkt zusammen",
  "Your detailed product review": "Ihre detaillierte Produktbewertung",
  "50 characters minimum": "Mindestens 50 Zeichen",
  "What was your impression of the product while testing? What did you like or dislike about the product? What conditions where present while testing the product?": "Was war Ihr Eindruck von dem Produkt während des Tests? Was haben Sie am Produkt gemocht oder nicht gemocht? Unter welchen Bedingungen wurde das Produkt getestet?",
  "50 characters (minimum)": "50 Zeichen (mindestens)",
  "Comments": "Kommentare",
  "Comments on the reception, the organization, the advice on the product…": "Kommentare zur Rezeption, Organisation, Beratung zum Produkt…",
  "Would you recommend this product to a friend?": "Würden Sie dieses Produkt einem Freund empfehlen?",
  "Would you be ready to buy this product?": "Wären Sie bereit, dieses Produkt zu kaufen?",
  "First name or pseudo": "Vorname oder Pseudonym",
  "Your name / nickname is published with your review": "Ihr Name / Spitzname wird mit Ihrer Bewertung veröffentlicht",
  "I have read and I accept the terms and conditions": "Ich habe die Allgemeinen Geschäftsbedingungen gelesen und akzeptiere sie",
  "of publication of the reviews": "der Veröffentlichung der Bewertungen",
  "and": "und",
  "the privacy policy": "die Datenschutzrichtlinie",
  "Post Review": "Bewertung veröffentlichen",
  "Very bad": "Sehr schlecht",
  "Bad": "Schlecht",
  "Average": "Durchschnittlich",
  "Good": "Gut",
  "Great!": "Großartig!",
  "Image caption": "Bildunterschrift",
  "No": "Nein",
  "Yes": "Ja",
  "Booking dates": "Buchungsdaten",
  "Registration": "Anmeldung",
  "Status": "Status",
  "Created at": "Erstellt am",
  "Actions": "Aktionen",
  "Cancel": "Stornieren",
  "This site is protected by reCAPTCHA.": "Diese Website ist durch reCAPTCHA geschützt.",
  "Google Privacy Policy": "Datenschutzerklärung von Google",
  "Google Terms of Service": "Nutzungsbedingungen von Google",
};